import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer"

import {baseStyles} from "../../styles"
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF"
import {DealerVehicleInfoPDF} from "../../components/DealerVehicleInfoPDF"
import {FinanceDealerPaymentInformationPDF} from "./FinanceDealerPaymentInformationPDF"
import {PurchaseDealerProfitInformationPDF} from "./PurchaseDealerProfitInformationPDF"
import {PurchaseDealerPriceBreakdownPDF} from "./PurchaseDealerPriceBreakdownPDF"
import {PurchaseDealerFinanceDetailsPDF} from "./PurchaseDealerFinanceDetailsPDF"
import {FinanceDealerRateInformationPDF} from "./FinanceDealerRateInformationPDF"
import {RebatesBreakdownPDF} from "../../components/RebatesBreakdownPDF"
import {HeaderPDF} from "../../components/HeaderPDF"
import {FooterPDF} from "../../components/FooterPDF"
import {BasePDF} from "../../BasePDF"
import {TradeInformationPDF} from "../../components/TradeInformationPDF";
import {buildPdfFileName} from "../../pdfFileName";

export const PurchaseDealerDisclosurePDF = ({companyName, dealState, ...props}) => (
    <BasePDF dealState={dealState} {...props}>
        <Document title={buildPdfFileName(dealState, 'Dealer')}>
            <Page size="A4" style={baseStyles.page} wrap={false}>
                <View style={baseStyles.container}>
                    <HeaderPDF pdfName="Dealer Worksheet" companyName={companyName}/>
                    <DealerVehicleInfoPDF/>

                    <View style={baseStyles.mainGrid}>
                        <View style={[baseStyles.column, baseStyles.columnLeft]}>
                            <FinanceDealerPaymentInformationPDF/>
                            <PurchaseDealerProfitInformationPDF/>
                            <FinanceDealerRateInformationPDF/>
                            <RebatesBreakdownPDF/>
                            <TradeInformationPDF />
                        </View>

                        <View style={[baseStyles.column, baseStyles.columnRight]}>
                            <PurchaseDealerPriceBreakdownPDF/>
                            <PurchaseDealerFinanceDetailsPDF/>
                            <FeeBreakdownPDF/>
                        </View>
                    </View>

                    <FooterPDF showCompanyLogo/>
                </View>
            </Page>
        </Document>
    </BasePDF>
)
